import SupportTemplate from '../../templates/settings/ui/support';

export default function SupportPage() {
  return <SupportTemplate />;
}
